import React from 'react';
import { useRecoilValue } from 'recoil';
import { RoutesStates, RoutesStatesAtom } from '../../atoms/routesStates';
import { CustomerAtom } from '../../atoms/customerAtom';
// import {ReactHome} from '../ReactHome';
// import {StockTracker} from '../StockTracker';
// import {StockMovement} from '../stockMovement';
// import {StockReasoning} from '../StockReasoning';
import { Header } from '../Header';
import { Footer } from '../Footer';
import Home from '../Home';
import { OpenApiDoc } from '../Doc';
import {ComingSoon} from '../ComingSoon';
import { HashRouter as Router, Route, Routes } from 'react-router-dom';
import {LoginPage, SignUpPage} from '../loginPage';
import { NotFoundPage } from '../default';
import { PricingPage } from '../pricing';
import {Contact} from '../contact';
import { Company } from '../company';
import { Profile } from '../profile';
import { TickerDataDownload } from '../download/TickerDataDownload';
import { CandlestickChart } from '../CandlestickChart';
import { CandlestickWithIsin } from '../CandlestickChart/utils';
import { useTheme } from '../../context/ThemeContext';

export const App: React.FC = () => {
  const state = useRecoilValue(RoutesStatesAtom);
  const customer = useRecoilValue(CustomerAtom);
  const { isDarkMode } = useTheme();

  const appMainFragment = () => {
    switch (state) {
      case RoutesStates.HOME:
        return <Home />;
      // case RoutesStates.Momentum:
      //   return <StockTracker />;
      // case RoutesStates.Trending:
      //   return <StockTracker />;
      // case RoutesStates.Movement:
      //   return <StockMovement />;
      // case RoutesStates.Reasoning:
      //   return <StockReasoning />;
      default:
        return <ComingSoon/>;
    }
  }

  const doc = () => {
    return (
      <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
        <Header/>
        <OpenApiDoc/>
        <Footer/>
      </div>
    )
  }

  const renderingPage = (routesName : RoutesStates) => {
    switch (routesName) {
      case RoutesStates.HOME:
        return <Home />;
      case RoutesStates.DOCS:
        return <OpenApiDoc />;
      case RoutesStates.PRICING:
        return <PricingPage />;
      case RoutesStates.CONTACT:
        return <Contact />;
      case RoutesStates.COMPANY:
        return <Company/>
      case RoutesStates.LOGIN:
        return <LoginPage />;
      case RoutesStates.SIGNUP:
        return <SignUpPage />;
      case RoutesStates.PROFILE:
        return <Profile />;
      case RoutesStates.DOWNLOAD:
        return customer ? <TickerDataDownload customer={customer} /> : <LoginPage />;
      case RoutesStates.CANDLESTICK:
        return <CandlestickChart />;
      case RoutesStates.CANDLESTICK_CHART:
        return <CandlestickWithIsin />;
      case RoutesStates.UNKNOWN:
        return <ComingSoon/>;
      default:
        return <NotFoundPage/>;
    }
  }

  const page = (renderingPageRoute: RoutesStates) => {
    return (
      <div className={`min-h-screen ${isDarkMode ? 'bg-gray-900' : 'bg-gray-50'}`}>
        <Header/>
        {renderingPage(renderingPageRoute)}
        <Footer/>
      </div>
    )
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={page(RoutesStates.HOME)} />
        <Route path="/docs" element={page(RoutesStates.DOCS)} />
        <Route path="/products" element={page(RoutesStates.UNKNOWN)} />
        <Route path="/pricing" element={page(RoutesStates.PRICING)} />
        <Route path="/company" element={page(RoutesStates.COMPANY)} />
        <Route path="/contact" element={page(RoutesStates.CONTACT)} />
        <Route path="/signup" element={page(RoutesStates.SIGNUP)} />
        <Route path="/login" element={page(RoutesStates.LOGIN)} />
        <Route path="/profile" element={page(RoutesStates.PROFILE)} />
        <Route path="/download" element={page(RoutesStates.DOWNLOAD)} />
        <Route path="/candlestick" element={page(RoutesStates.CANDLESTICK)} />
        <Route path="/candlestick/:isin" element={page(RoutesStates.CANDLESTICK_CHART)} />
      </Routes>
    </Router>
  );
};
